const noop = () => { };

export { noop };
